export default (context) => {
    let arr = {}
    let is_validate_token = false
    if(context.$route.query.code) {

        arr.code = context.$route.query.code
        is_validate_token = true
        arr.order = Number(context.$route.query.order)

    } else if (context.token){
        arr.tocken = context.token
        arr.order = context.order
        is_validate_token = true

    } else {
        context.$router.push('/auth-check-order')
    }

    if(is_validate_token) {
        context.$axios.post(`getOrderState`, arr)
            .then(({ data }) => {
                if(data.success) {
                    data.order = context.$route.query.order
                    context.orders = []
                    context.orders.push(data)
                } else {
                    context.overlay = true
                    context.error.status = true
                    context.error.text = data.error
                }

            })
            .catch(e => {
                console.error(e)
                context.error.text = 'Ошибка сервера! Не удалось получить список заказов. Повторите попытку позже.'
                context.overlay = true
                context.error.status = true
            })
    }
}